/**
 * InfoModulesContext – lädt die Info-Module des Kunden aus der API.
 * Wird in der Sidebar verwendet, um das Info-Dropdown dynamisch zu befüllen.
 */
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const InfoModulesContext = createContext({ modules: [], loading: false, reload: () => {} });

export const InfoModulesProvider = ({ children }) => {
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadModules = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) return;
    try {
      setLoading(true);
      const res = await axios.get(`${API}/api/info/modules`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setModules(res.data || []);
    } catch {
      // Fehler still ignorieren – ältere Accounts ohne Seeder
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Load immediately if token is present (e.g. page reload with existing session)
    const token = localStorage.getItem('token');
    if (token) {
      loadModules();
      return;
    }
    // Otherwise poll every 300ms until a token appears (handles fresh logins)
    const interval = setInterval(() => {
      const t = localStorage.getItem('token');
      if (t) {
        loadModules();
        clearInterval(interval);
      }
    }, 300);
    return () => clearInterval(interval);
  }, [loadModules]);

  return (
    <InfoModulesContext.Provider value={{ modules, loading, reload: loadModules }}>
      {children}
    </InfoModulesContext.Provider>
  );
};

export const useInfoModules = () => useContext(InfoModulesContext);
